// import React, { useState, useRef, useEffect } from 'react';
// import { apiCall } from '@/api/apiCall';
// import { toast } from 'sonner';
// import { useApiQueue } from '@/hooks/useApiQueue';
// import OnStreet from '@/assets/img/TaifContract-onStreet.png';
// import Enforcement from '@/assets/img/TaifContract-Enforcement.png';
// import Khamis from '@/assets/img/Khamis.png';
// import CarPark from '@/assets/img/TaifContract-carPark.png';
// import { AssetsPanel } from '../../components/shared/AssetsPanel';
// import { API_CALL_TIME } from '@/constants/constant';

// // ═══════════════════════════════════════════════════════════════════════
// // HELPERS
// // ═══════════════════════════════════════════════════════════════════════
// const groupsToFlat = (groups = []) => {
//   const result = [];
//   groups.forEach(g => {
//     result.push({ name: g.group_name || '', isCategory: true, subCount: '', totalCount: String(g.group_total_qty ?? '-') });
//     (g.items || []).forEach(item => {
//       result.push({ name: item.item_name || '', isCategory: false, subCount: String(item.qty ?? '-'), totalCount: '' });
//     });
//   });
//   return result;
// };

// const flatToGroups = (flat) => {
//   const groups = [];
//   let cur = null;
//   flat.forEach(a => {
//     if (a.isCategory) {
//       if (cur) groups.push(cur);
//       cur = { group_name: a.name, group_total_qty: a.totalCount || '', items: [] };
//     } else if (cur) {
//       cur.items.push({ item_name: a.name, qty: a.subCount || '' });
//     }
//   });
//   if (cur) groups.push(cur);
//   return groups;
// };

// // ═══════════════════════════════════════════════════════════════════════
// // ASSET GROUPS HELPER
// // ═══════════════════════════════════════════════════════════════════════
// function makeAssetGroups(o = {}) {
//   return [
//     { group_name: 'Ticket Dispenser',    group_total_qty: o.ticketDispenser ?? '-', items: [{ item_name: 'DIP G100', qty: '-' }, { item_name: 'G100 64 Bit', qty: o.g10064 ?? '-' }, { item_name: 'G100 32 Bit', qty: '-' }] },
//     { group_name: 'Ticket Verifier',     group_total_qty: o.ticketVerifier  ?? '-', items: [{ item_name: 'EV DIP G100', qty: '-' }, { item_name: 'EV G100 64 Bit', qty: o.evG10064 ?? '-' }, { item_name: 'EV G100 32 Bit', qty: '-' }] },
//     { group_name: "APM's",               group_total_qty: o.apms            ?? '-', items: [{ item_name: 'APM ETS-70', qty: '-' }, { item_name: 'APM ETS-100', qty: '-' }] },
//     { group_name: 'PIN Pad',             group_total_qty: o.pinPad          ?? '-', items: [{ item_name: 'IUP250', qty: '-' }] },
//     { group_name: 'Card Reader',         group_total_qty: o.cardReader      ?? '-', items: [{ item_name: 'IUR250', qty: '-' }] },
//     { group_name: 'B-Contactless',       group_total_qty: o.bContactless    ?? '-', items: [{ item_name: 'IUC150', qty: '-' }] },
//     { group_name: 'RFID Reader',         group_total_qty: o.rfidReader      ?? '-', items: [] },
//     { group_name: 'IP Barrier',          group_total_qty: o.ipBarrier       ?? '-', items: [] },
//     { group_name: 'ANPR CAMERA',         group_total_qty: o.anprCamera      ?? '-', items: [{ item_name: 'ARH', qty: o.arh ?? '-' }, { item_name: 'Luminera', qty: '-' }] },
//     { group_name: 'Sliding Gate',        group_total_qty: o.slidingGate     ?? '-', items: [{ item_name: 'RIGHT', qty: '-' }, { item_name: 'LEFT', qty: '-' }] },
//     { group_name: "PND's",               group_total_qty: o.pnds            ?? '-', items: [{ item_name: 'TPAL- BNA Large', qty: o.tpalBna ?? '-' }, { item_name: 'T-PAL TX', qty: o.tpalTx ?? '-' }, { item_name: 'T-PAL V2', qty: o.tpalV2 ?? '-' }] },
//     { group_name: 'Pound Cahier Device', group_total_qty: '-',                      items: [{ item_name: 'CN-50', qty: '-' }] },
//     { group_name: 'Driver Device',       group_total_qty: '-',                      items: [{ item_name: 'CN-51', qty: '-' }] },
//     { group_name: 'Enf Device',          group_total_qty: o.enfDevice       ?? '-', items: [{ item_name: 'Oukitel WP2', qty: o.oukitel ?? '-' }, { item_name: 'Doogee V10', qty: o.doogee ?? '-' }] },
//     { group_name: 'Validation',          group_total_qty: '-',                      items: [{ item_name: 'Lenova Tablet', qty: '-' }] },
//     { group_name: 'Printer',             group_total_qty: o.printer         ?? '-', items: [{ item_name: 'PR-3', qty: o.pr3 ?? '-' }, { item_name: 'SEWOO', qty: o.sewoo ?? '-' }, { item_name: 'BIXOLON', qty: o.bixolon ?? '-' }] },
//     { group_name: 'Tow Truck',           group_total_qty: o.towTruck        ?? '-', items: [] },
//     { group_name: 'Clamp Vehicle',       group_total_qty: o.clampVehicle    ?? '-', items: [] },
//     { group_name: 'Support Vehicle',     group_total_qty: o.supportVehicle  ?? '-', items: [] },
//   ];
// }

// // ═══════════════════════════════════════════════════════════════════════
// // CONFIG
// // ═══════════════════════════════════════════════════════════════════════
// const KHAMIS_PROFILE_CONFIG = {


  
//   // ── Khamis On-Street ────────────────────────────────────────────────
//   khamis_on_street_profile: {
//     profileKey:   'khamis_on_street_profile',
//     violationKey: 'khamis_on_street_violations',
//     assetsKey:    'khamis_on_street_assets',
//     pageType:     'on_street',

//     profileFallback: {
//       table_key: 'khamis_on_street_profile',
//       title: 'Khamis On Street - Profile',
//       data: {
//         total_bays:        { label: 'Total On-Street Parking Bays', value: '1,589' },
//         contract_term:     { value: '15 years' },
//         contract_period:   { start_date: '19.11.2015', end_date: '17.06.2030' },
//         operational_hours: { value: '16 Hours', from: '07:30', to: '23:30' },
//         rate_per_hour:     { value: 'SAR 3.00 excluding 15% VAT' },
//       },
//     },

//     violationFallback: {
//       table_key: 'khamis_on_street_violations',
//       title: 'Khamis Mushiyath On Street Violation Summary - Excluding 15% VAT',
//       data: {
//         rows: [
//           { city_cd: 'KHA', violation_cd: '10',  violation_name: 'Parked without displaying a valid parking ticket',            ticket_charges: 'SAR 100', tow_charges: 'SAR 100', clamp_charges: 'SAR 75' },
//           { city_cd: 'KHA', violation_cd: '11',  violation_name: 'Parking a vehicle larger than the marked space',              ticket_charges: 'SAR 150', tow_charges: 'SAR 100', clamp_charges: 'SAR 75' },
//           { city_cd: 'KHA', violation_cd: '12',  violation_name: 'Parked with a wheel on pedesterian area or road',             ticket_charges: 'SAR 200', tow_charges: 'SAR 100', clamp_charges: 'SAR 75' },
//           { city_cd: 'KHA', violation_cd: '13',  violation_name: 'Not parked within space markings',                            ticket_charges: 'SAR 100', tow_charges: 'SAR 100', clamp_charges: 'SAR 75' },
//           { city_cd: 'KHA', violation_cd: '14',  violation_name: 'Parked/overstayed in a loading/unloading space',              ticket_charges: 'SAR 100', tow_charges: 'SAR 100', clamp_charges: 'SAR 75' },
//           { city_cd: 'KHA', violation_cd: '15',  violation_name: 'Parked in a space for Special Needs without a valid permit',  ticket_charges: 'SAR 150', tow_charges: 'SAR 100', clamp_charges: 'SAR 75' },
//           { city_cd: 'KHA', violation_cd: '16',  violation_name: 'Parked without at least one license plate',                   ticket_charges: 'SAR 100', tow_charges: 'SAR 100', clamp_charges: 'SAR 75' },
//           { city_cd: 'KHA', violation_cd: '21',  violation_name: 'Park in Sand Areas',                                          ticket_charges: 'SAR 100', tow_charges: 'SAR 100', clamp_charges: 'SAR 75' },
//           { city_cd: 'KHA', violation_cd: '22',  violation_name: 'Obstructing an authorized personal from executing their duties', ticket_charges: 'SAR 200', tow_charges: 'SAR 100', clamp_charges: 'SAR 75' },
//           { city_cd: 'KHA', violation_cd: '800', violation_name: 'Parked within the road and traffic area',                     ticket_charges: 'SAR 150', tow_charges: 'SAR 100', clamp_charges: 'SAR 75' },
//           { city_cd: 'KHA', violation_cd: '801', violation_name: 'Parked in a non-parking area',                                ticket_charges: 'SAR 150', tow_charges: 'SAR 100', clamp_charges: 'SAR 75' },
//           { city_cd: 'KHA', violation_cd: '802', violation_name: 'Parked on pedestrian or buildings entries',                   ticket_charges: 'SAR 200', tow_charges: 'SAR 100', clamp_charges: 'SAR 75' },
//           { city_cd: 'KHA', violation_cd: '803', violation_name: 'Parked on the pavement or on a pedestrian area',              ticket_charges: 'SAR 150', tow_charges: 'SAR 100', clamp_charges: 'SAR 75' },
//           { city_cd: 'KHA', violation_cd: '804', violation_name: 'Parked facing the opposite direction of traffic flow',        ticket_charges: 'SAR 150', tow_charges: 'SAR 100', clamp_charges: 'SAR 75' },
//           { city_cd: 'KHA', violation_cd: '805', violation_name: 'Parked in an officially reserved space',                      ticket_charges: 'SAR 150', tow_charges: 'SAR 100', clamp_charges: 'SAR 75' },
//           { city_cd: 'KHA', violation_cd: '806', violation_name: 'Parked in a suspended space/temporary out of use',            ticket_charges: 'SAR 150', tow_charges: 'SAR 100', clamp_charges: 'SAR 75' },
//           { city_cd: 'KHA', violation_cd: '807', violation_name: 'Placing obstacles or reservations on the parking space',      ticket_charges: 'SAR 300', tow_charges: 'SAR 100', clamp_charges: 'SAR 75' },
//           { city_cd: 'KHA', violation_cd: '808', violation_name: 'Fencing or closing a parking space without a valid permit',   ticket_charges: 'SAR 200', tow_charges: 'SAR 100', clamp_charges: 'SAR 75' },
//           { city_cd: 'KHA', violation_cd: '809', violation_name: 'Parked outside allowed time',                                 ticket_charges: 'SAR 100', tow_charges: 'SAR 100', clamp_charges: 'SAR 75' },
//           { city_cd: 'KHA', violation_cd: '810', violation_name: 'Parked in violation of posted signs',                         ticket_charges: 'SAR 150', tow_charges: 'SAR 100', clamp_charges: 'SAR 75' },
//           { city_cd: 'KHA', violation_cd: '811', violation_name: 'Parked on a fire hydrant bay',                                ticket_charges: 'SAR 250', tow_charges: 'SAR 100', clamp_charges: 'SAR 75' },
//         ],
//       },
//     },

//     assetsFallback: {
//       table_key: 'khamis_on_street_assets',
//       title: 'Khamis On-street',
//       data: {
//         groups: makeAssetGroups({
//           ticketDispenser: '-', ticketVerifier: '-', apms: '-',
//           pinPad: '-', cardReader: '-', bContactless: '-',
//           rfidReader: '-', ipBarrier: '-', anprCamera: '-',
//           slidingGate: '-',
//           pnds: '119', tpalBna: '22', tpalTx: '72', tpalV2: '25',
//           enfDevice: '66', oukitel: '19', doogee: '47',
//           printer: '65', pr3: '24', sewoo: '5', bixolon: '36',
//           towTruck: '4', clampVehicle: '2', supportVehicle: '1',
//         }),
//       },
//     },
//   },

//   // ── Khamis Off-Street ───────────────────────────────────────────────
//   khamis_off_street_profile: {
//     profileKey:    'khamis_off_street_profile',
//     membershipKey: 'khamis_off_street_membership',
//     assetsKey:     'khamis_off_street_assets',
//     pageType:      'off_street',

//     profileFallback: {
//       table_key: 'khamis_off_street_profile',
//       title: 'Khamis Off-Street Profile',
//       data: {
//         total_bays:        { label: 'Total Off Street Car Park Bays', value: '125' },
//         contract_term:     { value: '15 years' },
//         contract_period:   { start_date: '19.11.2015', end_date: '17.06.2030' },
//         operational_hours: { value: '16 Hours', from: '07:30', to: '23:30' },
//         rate_per_hour:     { value: 'SAR 3.00 excluding 15% VAT' },
//         membership_tariff: { value: 'excluding 15% VAT' },
//       },
//     },

//     membershipFallback: {
//       table_key: 'khamis_off_street_membership',
//       title: 'Khamis Mushayith Off Street - Price List',
//       data: {
//         rows: [
//           { category: 'Membership', amount: 'SAR 350' },
//         ],
//       },
//     },

//     assetsFallback: {
//       table_key: 'khamis_off_street_assets',
//       title: 'Khamis Off-street',
//       data: {
//         groups: makeAssetGroups({
//           ticketDispenser: '1', g10064: '1',
//           ticketVerifier: '1', evG10064: '1',
//           apms: '-', pinPad: '-', cardReader: '-', bContactless: '-',
//           rfidReader: '3', ipBarrier: '2', anprCamera: '2', arh: '2',
//           slidingGate: '-', pnds: '-',
//           enfDevice: '-', printer: '-', towTruck: '-', clampVehicle: '-', supportVehicle: '-',
//         }),
//       },
//     },
//   },
// };


// // ═══════════════════════════════════════════════════════════════════════
// // SHARED PROFILE INFO BLOCK
// // ═══════════════════════════════════════════════════════════════════════
// const ProfileInfo = ({ pd, pageType, patchProfile, showMembership }) => (
//   <div className="flex flex-col gap-1 mb-4">
//     {/* Total Bays */}
//     <div className="flex items-center gap-2">
//       <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//       <span className="text-[12px]">
//         {pd.total_bays?.label}{' '}
//         <strong>
//           <input type="text" value={pd.total_bays?.value || ''}
//             onChange={e => patchProfile('total_bays', 'value', e.target.value)}
//             className="font-bold outline-none bg-transparent !border-0 text-[12px] w-20" />
//         </strong>
//       </span>
//     </div>

//     {/* Contract Term */}
//     <div className="flex items-center gap-2 ml-4">
//       <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//       <span className="text-[12px] flex items-center flex-wrap gap-1">
//         Contract term{' '}
//         <strong><input type="text" value={pd.contract_term?.value || ''}
//           onChange={e => patchProfile('contract_term', 'value', e.target.value)}
//           className="font-bold outline-none bg-transparent !border-0 text-[12px] w-12" /></strong>
//         ; start date{' '}
//         <strong><input type="text" value={pd.contract_period?.start_date || ''}
//           onChange={e => patchProfile('contract_period', 'start_date', e.target.value)}
//           className="font-bold outline-none bg-transparent !border-0 text-[12px] w-16" /></strong>
//         {' to '}
//         <strong><input type="text" value={pd.contract_period?.end_date || ''}
//           onChange={e => patchProfile('contract_period', 'end_date', e.target.value)}
//           className="font-bold outline-none bg-transparent !border-0 text-[12px] w-24" /></strong>
//       </span>
//     </div>

//     {/* Operational Hours */}
//     <div className="flex items-center gap-2 ml-4">
//       <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//       <span className="text-[12px] flex items-center flex-wrap gap-1">
//         Operational Hours{' '}
//         <strong><input type="text" value={pd.operational_hours?.value || ''}
//           onChange={e => patchProfile('operational_hours', 'value', e.target.value)}
//           className="font-bold outline-none bg-transparent !border-0 text-[12px] w-13" /></strong>
//         {' Per day '}
//         <strong><input type="text" value={pd.operational_hours?.from || ''}
//           onChange={e => patchProfile('operational_hours', 'from', e.target.value)}
//           className="font-bold outline-none bg-transparent !border-0 text-[12px] w-9" /></strong>
//         {' Hours to '}
//         <strong><input type="text" value={pd.operational_hours?.to || ''}
//           onChange={e => patchProfile('operational_hours', 'to', e.target.value)}
//           className="font-bold outline-none bg-transparent !border-0 text-[12px] w-9" /></strong>
//         {' Hours'}
//       </span>
//     </div>

//     {/* Rate Per Hour */}
//     <div className="flex items-center gap-2 ml-4">
//       <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//       <span className="text-[12px]">
//         Rate per Hour{' '}
//         <strong><input type="text" value={pd.rate_per_hour?.value || ''}
//           onChange={e => patchProfile('rate_per_hour', 'value', e.target.value)}
//           className="font-bold outline-none bg-transparent !border-0 text-[12px] w-48" /></strong>
//       </span>
//     </div>

//     {/* Assets Deployed */}
//     <div className="flex items-center gap-2 ml-4">
//       <div className="w-3 h-3 rounded-full bg-red-500 flex-shrink-0" />
//       <span className="text-[12px]">Assets Deployed</span>
//     </div>

//     {/* Membership line — off-street only */}
//     {showMembership && (
//       <div className="flex items-center gap-2 ml-4">
//         <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//         <span className="text-[12px]">
//           Membership Rates{' '}
//         <strong>
//           <input type="text" value={pd.membership_tariff?.value || ''}
//             onChange={e => patchProfile('membership_tariff', 'value', e.target.value)}
//             className=" outline-none bg-transparent !border-0 text-[12px] w-72" />
//         </strong>
//         </span>
        
//       </div>
//     )}
//   </div>
// );

// // ═══════════════════════════════════════════════════════════════════════
// // MAIN COMPONENT
// // ═══════════════════════════════════════════════════════════════════════
// const KhamisProfile = ({ page, year = '', monthNumber = '', contract = '' }) => {
//   const cfg = KHAMIS_PROFILE_CONFIG[page?.type];
//   if (!cfg) return null;

//   const hasFetchedRef = useRef(false);
//   const saveRef       = useRef(null);
//   const [isSaving, setIsSaving]               = useState(false);
//   const [profileTable, setProfileTable]       = useState(cfg.profileFallback);
//   const [assetsTable, setAssetsTable]         = useState(cfg.assetsFallback);
//   const [violationTable, setViolationTable]   = useState(cfg.violationFallback || null);
//   const [membershipTable, setMembershipTable] = useState(cfg.membershipFallback || null);
//   const { enqueue } = useApiQueue();

//     // ── Refs for latest state (Stale State Fix) ─────────────────────────────
//   const profileRef     = useRef(null);
//   const assetsRef      = useRef(null);
//   const violationRef   = useRef(null);
//   const membershipRef  = useRef(null);

//   // Sync refs with latest state
//   useEffect(() => { profileRef.current   = profileTable;   }, [profileTable]);
//   useEffect(() => { assetsRef.current    = assetsTable;    }, [assetsTable]);
//   useEffect(() => { violationRef.current = violationTable; }, [violationTable]);
//   useEffect(() => { membershipRef.current = membershipTable; }, [membershipTable]);
//   // ── Fetch ─────────────────────────────────────────────────────────────
//   useEffect(() => {
//     if (hasFetchedRef.current) return;
//     hasFetchedRef.current = true;
//     fetchData();
//   }, [year, monthNumber, contract]);

//   const fetchData = async () => {
//     try {
//       const res = await enqueue(() => apiCall('GET', '/boardpack/get-tables-data', { year, contract, month: monthNumber }));
//       if (!res?.success) return;
//       const data = res?.data || [];
//       const find = (key, fb) => data.find(t => t.table_key === key) || fb;

//       setProfileTable(find(cfg.profileKey, cfg.profileFallback));
//       setAssetsTable(find(cfg.assetsKey, cfg.assetsFallback));
//       if (cfg.violationKey)  setViolationTable(find(cfg.violationKey, cfg.violationFallback));
//       if (cfg.membershipKey) setMembershipTable(find(cfg.membershipKey, cfg.membershipFallback));
//     } catch (err) {
//       console.error('Fetch error:', err);
//     }
//   };

//   // ── Auto-save ─────────────────────────────────────────────────────────
//   const autoSave = () => {
//     if (saveRef.current) clearTimeout(saveRef.current);
//     saveRef.current = setTimeout(saveToAPI, API_CALL_TIME);
//   };

//     // ── Fixed saveToAPI using Refs ────────────────────────────────────────────
//   const saveToAPI = async () => {
//     try {
//       setIsSaving(true);

//       const tables = [
//         { 
//           table_key: profileRef.current?.table_key, 
//           title: profileRef.current?.title, 
//           data: profileRef.current?.data 
//         },
//         { 
//           table_key: assetsRef.current?.table_key, 
//           title: assetsRef.current?.title, 
//           data: assetsRef.current?.data 
//         },
//       ];

//       if (violationRef.current) {
//         tables.push({ 
//           table_key: violationRef.current.table_key, 
//           title: violationRef.current.title, 
//           data: violationRef.current.data 
//         });
//       }
//       if (membershipRef.current) {
//         tables.push({ 
//           table_key: membershipRef.current.table_key, 
//           title: membershipRef.current.title, 
//           data: membershipRef.current.data 
//         });
//       }

//       const res = await apiCall('POST', '/boardpack/add-tables-data', {
//         contract, 
//         year, 
//         month: monthNumber, 
//         created_by: 1, 
//         tables,
//       });

//       if (!res?.success) throw new Error(res?.message || 'Save failed');
//     } catch (err) {
//       console.error('Save error:', err);
//       toast.error('Failed to save changes');
//     } finally {
//       setIsSaving(false);
//     }
//   };

//   // ── Patch helpers ─────────────────────────────────────────────────────
//   const patchProfile = (field, subField, value) => {
//     setProfileTable(prev => ({
//       ...prev,
//       data: { ...prev.data, [field]: subField ? { ...prev.data[field], [subField]: value } : value },
//     }));
//     autoSave();
//   };

//   const handleViolationCell = (rIdx, key, value) => {
//     setViolationTable(prev => ({
//       ...prev,
//       data: { ...prev.data, rows: prev.data.rows.map((r, i) => i === rIdx ? { ...r, [key]: value } : r) },
//     }));
//     autoSave();
//   };

//   const handleMembershipCell = (rIdx, key, value) => {
//     setMembershipTable(prev => ({
//       ...prev,
//       data: { ...prev.data, rows: prev.data.rows.map((r, i) => i === rIdx ? { ...r, [key]: value } : r) },
//     }));
//     autoSave();
//   };

//   const handleAssetSubCount = (flatIdx, value) => {
//     const flat = groupsToFlat(assetsTable.data.groups).map((a, i) => i === flatIdx ? { ...a, subCount: value } : a);
//     setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
//     autoSave();
//   };

//   const handleAssetTotalCount = (flatIdx, value) => {
//     const flat = groupsToFlat(assetsTable.data.groups).map((a, i) => i === flatIdx ? { ...a, totalCount: value } : a);
//     setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
//     autoSave();
//   };

//   const pd         = profileTable.data;
//   const flatAssets = groupsToFlat(assetsTable.data.groups);
//   const pageType   = cfg.pageType;

//   // ═══════════════════════════════════════════════════════════════════
//   // RENDER
//   // ═══════════════════════════════════════════════════════════════════
//   return (
//     <div className="min-h-screen p-4 md:p-6 lg:p-8 bg-white">

//       {/* ── Header ── */}
//       <div className="flex justify-between items-center mb-3">
//         <div className="ml-2">
//           {/* Replace with: import KhamisLogo from '@/assets/img/KhamisLogo.png' */}
// <img src={Khamis} alt="Bab Al Ree Logo" style={{ height: '50px', objectFit: 'contain' }} />         </div>
//         <h1 className="text-xl font-bold flex-1 text-center">{profileTable.title}</h1>
//       </div>

//       {/* ══════════════════════════════════════
//           ON-STREET PAGE
//       ══════════════════════════════════════ */}
//       {pageType === 'on_street' && (
//         <>
          

//           <div className="flex flex-col lg:flex-row gap-0 !border-2 !border-black p-3">
//             {/* LEFT */}
//             <div className="flex-1 pr-4">
//               <div className="flex flex-col">
// {/* Activities icons */}
//           <div className=" mb-4">
//             <div className="flex gap-8">
//               <p className="text-[16px] font-bold mb-3">Activities:</p>
//               {['On Street', 'Enforcement'].map(label => (
//                 <div key={label} className="flex flex-col items-center gap-2">
                  
//                     {label === 'On Street' ? <img src={OnStreet} alt="Bab Al Ree Logo" style={{ height: '120px', objectFit: 'contain' }} />  : <img src={Enforcement} alt="Bab Al Ree Logo" style={{ height: '120px', objectFit: 'contain' }} />}
                  
                 
//                 </div>
//               ))}
//             </div>
//           </div>
//               <ProfileInfo pd={pd} pageType={pageType} patchProfile={patchProfile} showMembership={false} />
//               </div>

//               {/* Violation Table */}
//               {violationTable && (
//                 <div className=" mt-2">
//                   <p className="text-[9px] font-semibold mb-1">{violationTable.title}</p>
//                   <table className="!border-collapse text-[8px]">
//                     <thead>
//                       <tr className="bg-gray-300">
//                         {['City_Cd', 'Violation_Cd', 'Violation_Name_En', 'Ticket_Charges', 'Tow_Charges', 'Clamp_Charges'].map(h => (
//                           <th key={h} className="!border !border-black px-2 py-1 font-bold text-center"
//                             style={{ minWidth: h === 'Violation_Name_En' ? '200px' : '65px' }}>
//                             {h}
//                           </th>
//                         ))}
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {violationTable.data.rows.map((row, rIdx) => (
//   <tr key={rIdx} className="bg-white">
//     {[
//       { key: 'city_cd', w: '45px' },
//       { key: 'violation_cd', w: '50px' },
//       { key: 'violation_name', isLong: true },
//       { key: 'ticket_charges', w: '60px' },
//       { key: 'tow_charges', w: '60px' },
//       { key: 'clamp_charges', w: '60px' },
//     ].map(({ key, w, isLong }) => (
//       <td key={key} className="!border !border-black px-1 py-0.5 align-top">
//         {isLong ? (
//           <textarea
//             value={row[key] || ''}
//             onChange={e => handleViolationCell(rIdx, key, e.target.value)}
//             rows={1}
//             className="!border-0 bg-transparent outline-none text-[8px] resize-none w-full"
//             style={{ minWidth: '260px', overflow: 'hidden' }}
//             onInput={e => {
//               e.target.style.height = 'auto';
//               e.target.style.height = e.target.scrollHeight + 'px';
//             }}
//           />
//         ) : (
//           <input
//             type="text"
//             value={row[key] || ''}
//             onChange={e => handleViolationCell(rIdx, key, e.target.value)}
//             className="!border-0 bg-transparent outline-none text-[8px] text-center"
//             style={{ width: w }}
//           />
//         )}
//       </td>
//     ))}
//   </tr>
// ))}
//                     </tbody>
//                   </table>
//                 </div>
//               )}
//             </div>

//             {/* RIGHT — Assets */}
//             <AssetsPanel assetsTable={assetsTable} flatAssets={flatAssets}
//               onSubCount={handleAssetSubCount} onTotalCount={handleAssetTotalCount} />
//           </div>
//         </>
//       )}

//       {/* ══════════════════════════════════════
//           OFF-STREET PAGE
//       ══════════════════════════════════════ */}
//       {pageType === 'off_street' && (
//         <div className="flex flex-col lg:flex-row gap-0 !border-2 !border-black p-3">
//           {/* LEFT */}
//           <div className="flex-1 pr-4">
//             {/* Car Park icon + info */}
//             <div className="flex items-start gap-4 mb-4">
//               <div className=" items-center justify-center text-[8px] text-gray-400"><img src={CarPark} alt="Bab Al Ree Logo" style={{ height: '50px', objectFit: 'contain' }} /></div>
              
//               <div className="flex-1">
//                 <ProfileInfo pd={pd} pageType={pageType} patchProfile={patchProfile} showMembership={true} />
//               </div>
//             </div>

//             {/* Price List Table */}
//             {membershipTable && (
//               <div className="ml-4">
//                 <p className="text-[9px] font-semibold mb-2">{membershipTable.title}</p>
//                 <table className="!border-collapse text-[10px]">
//                   <thead>
//                     <tr className="bg-gray-300">
//                       <th className="!border !border-black px-6 py-2 font-bold text-left" style={{ minWidth: '250px' }}>Category</th>
//                       <th className="!border !border-black px-6 py-2 font-bold text-center" style={{ minWidth: '120px' }}>Amount</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {membershipTable.data.rows.map((row, rIdx) => (
//                       <tr key={rIdx} className="bg-white">
//                         <td className="!border !border-black px-4 py-2">
//                           <input type="text" value={row.category || ''} onChange={e => handleMembershipCell(rIdx, 'category', e.target.value)}
//                             className="!border-0 bg-transparent outline-none text-[10px] w-full" />
//                         </td>
//                         <td className="!border !border-black px-4 py-2 text-center">
//                           <input type="text" value={row.amount || ''} onChange={e => handleMembershipCell(rIdx, 'amount', e.target.value)}
//                             className="!border-0 bg-transparent outline-none text-[10px] text-center w-full" />
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             )}
//           </div>

//           {/* RIGHT — Assets */}
//           <AssetsPanel assetsTable={assetsTable} flatAssets={flatAssets}
//             onSubCount={handleAssetSubCount} onTotalCount={handleAssetTotalCount} />
//         </div>
//       )}

//       {/* {isSaving && (
//         <div className="fixed bottom-4 right-4 bg-blue-600 text-white text-xs px-3 py-1.5 rounded shadow-lg z-50">
//           Saving...
//         </div>
//       )} */}
//     </div>
//   );
// };

// export default KhamisProfile;











import React, { useState, useRef, useEffect } from 'react';
import { apiCall } from '@/api/apiCall';
import { toast } from 'sonner';
import { useApiQueue } from '@/hooks/useApiQueue';
import OnStreet from '@/assets/img/TaifContract-onStreet.png';
import Enforcement from '@/assets/img/TaifContract-Enforcement.png';
import Khamis from '@/assets/img/Khamis.png';
import CarPark from '@/assets/img/TaifContract-carPark.png';
import { AssetsPanel } from '../../components/shared/AssetsPanel';
import { API_CALL_TIME } from '@/constants/constant';

// ═══════════════════════════════════════════════════════════════════════
// HELPERS
// ═══════════════════════════════════════════════════════════════════════
const groupsToFlat = (groups = []) => {
  const result = [];
  groups.forEach(g => {
    result.push({ name: g.group_name || '', isCategory: true, subCount: '', totalCount: String(g.group_total_qty ?? '-') });
    (g.items || []).forEach(item => {
      result.push({ name: item.item_name || '', isCategory: false, subCount: String(item.qty ?? '-'), totalCount: '' });
    });
  });
  return result;
};

const flatToGroups = (flat) => {
  const groups = [];
  let cur = null;
  flat.forEach(a => {
    if (a.isCategory) {
      if (cur) groups.push(cur);
      cur = { group_name: a.name, group_total_qty: a.totalCount || '', items: [] };
    } else if (cur) {
      cur.items.push({ item_name: a.name, qty: a.subCount || '' });
    }
  });
  if (cur) groups.push(cur);
  return groups;
};

// ═══════════════════════════════════════════════════════════════════════
// ASSET GROUPS HELPER
// ═══════════════════════════════════════════════════════════════════════
function makeAssetGroups(o = {}) {
  return [
    { group_name: 'Ticket Dispenser',    group_total_qty: o.ticketDispenser ?? '-', items: [{ item_name: 'DIP G100', qty: '-' }, { item_name: 'G100 64 Bit', qty: o.g10064 ?? '-' }, { item_name: 'G100 32 Bit', qty: '-' }] },
    { group_name: 'Ticket Verifier',     group_total_qty: o.ticketVerifier  ?? '-', items: [{ item_name: 'EV DIP G100', qty: '-' }, { item_name: 'EV G100 64 Bit', qty: o.evG10064 ?? '-' }, { item_name: 'EV G100 32 Bit', qty: '-' }] },
    { group_name: "APM's",               group_total_qty: o.apms            ?? '-', items: [{ item_name: 'APM ETS-70', qty: '-' }, { item_name: 'APM ETS-100', qty: '-' }] },
    { group_name: 'PIN Pad',             group_total_qty: o.pinPad          ?? '-', items: [{ item_name: 'IUP250', qty: '-' }] },
    { group_name: 'Card Reader',         group_total_qty: o.cardReader      ?? '-', items: [{ item_name: 'IUR250', qty: '-' }] },
    { group_name: 'B-Contactless',       group_total_qty: o.bContactless    ?? '-', items: [{ item_name: 'IUC150', qty: '-' }] },
    { group_name: 'RFID Reader',         group_total_qty: o.rfidReader      ?? '-', items: [] },
    { group_name: 'IP Barrier',          group_total_qty: o.ipBarrier       ?? '-', items: [] },
    { group_name: 'ANPR CAMERA',         group_total_qty: o.anprCamera      ?? '-', items: [{ item_name: 'ARH', qty: o.arh ?? '-' }, { item_name: 'Luminera', qty: '-' }] },
    { group_name: 'Sliding Gate',        group_total_qty: o.slidingGate     ?? '-', items: [{ item_name: 'RIGHT', qty: '-' }, { item_name: 'LEFT', qty: '-' }] },
    { group_name: "PND's",               group_total_qty: o.pnds            ?? '-', items: [{ item_name: 'TPAL- BNA Large', qty: o.tpalBna ?? '-' }, { item_name: 'T-PAL TX', qty: o.tpalTx ?? '-' }, { item_name: 'T-PAL V2', qty: o.tpalV2 ?? '-' }] },
    { group_name: 'Pound Cahier Device', group_total_qty: '-',                      items: [{ item_name: 'CN-50', qty: '-' }] },
    { group_name: 'Driver Device',       group_total_qty: '-',                      items: [{ item_name: 'CN-51', qty: '-' }] },
    { group_name: 'Enf Device',          group_total_qty: o.enfDevice       ?? '-', items: [{ item_name: 'Oukitel WP2', qty: o.oukitel ?? '-' }, { item_name: 'Doogee V10', qty: o.doogee ?? '-' }] },
    { group_name: 'Validation',          group_total_qty: '-',                      items: [{ item_name: 'Lenova Tablet', qty: '-' }] },
    { group_name: 'Printer',             group_total_qty: o.printer         ?? '-', items: [{ item_name: 'PR-3', qty: o.pr3 ?? '-' }, { item_name: 'SEWOO', qty: o.sewoo ?? '-' }, { item_name: 'BIXOLON', qty: o.bixolon ?? '-' }] },
    { group_name: 'Tow Truck',           group_total_qty: o.towTruck        ?? '-', items: [] },
    { group_name: 'Clamp Vehicle',       group_total_qty: o.clampVehicle    ?? '-', items: [] },
    { group_name: 'Support Vehicle',     group_total_qty: o.supportVehicle  ?? '-', items: [] },
  ];
}

// ═══════════════════════════════════════════════════════════════════════
// CONFIG
// ═══════════════════════════════════════════════════════════════════════
const KHAMIS_PROFILE_CONFIG = {


  
  // ── Khamis On-Street ────────────────────────────────────────────────
  khamis_on_street_profile: {
    profileKey:   'khamis_on_street_profile',
    violationKey: 'khamis_on_street_violations',
    assetsKey:    'khamis_on_street_assets',
    pageType:     'on_street',

    profileFallback: {
      table_key: 'khamis_on_street_profile',
      title: 'Khamis On Street - Profile',
      data: {
        total_bays:        { label: 'Total On-Street Parking Bays', value: '1,589' },
        contract_term:     { value: '15 years' },
        contract_period:   { start_date: '19.11.2015', end_date: '17.06.2030' },
        operational_hours: { value: '16 Hours', from: '07:30', to: '23:30' },
        rate_per_hour:     { value: 'SAR 3.00 excluding 15% VAT' },
      },
    },

    violationFallback: {
      table_key: 'khamis_on_street_violations',
      title: 'Khamis Mushiyath On Street Violation Summary - Excluding 15% VAT',
      data: {
        rows: [
          { city_cd: 'KHA', violation_cd: '10',  violation_name: 'Parked without displaying a valid parking ticket',            ticket_charges: 'SAR 100', tow_charges: 'SAR 100', clamp_charges: 'SAR 75' },
          { city_cd: 'KHA', violation_cd: '11',  violation_name: 'Parking a vehicle larger than the marked space',              ticket_charges: 'SAR 150', tow_charges: 'SAR 100', clamp_charges: 'SAR 75' },
          { city_cd: 'KHA', violation_cd: '12',  violation_name: 'Parked with a wheel on pedesterian area or road',             ticket_charges: 'SAR 200', tow_charges: 'SAR 100', clamp_charges: 'SAR 75' },
          { city_cd: 'KHA', violation_cd: '13',  violation_name: 'Not parked within space markings',                            ticket_charges: 'SAR 100', tow_charges: 'SAR 100', clamp_charges: 'SAR 75' },
          { city_cd: 'KHA', violation_cd: '14',  violation_name: 'Parked/overstayed in a loading/unloading space',              ticket_charges: 'SAR 100', tow_charges: 'SAR 100', clamp_charges: 'SAR 75' },
          { city_cd: 'KHA', violation_cd: '15',  violation_name: 'Parked in a space for Special Needs without a valid permit',  ticket_charges: 'SAR 150', tow_charges: 'SAR 100', clamp_charges: 'SAR 75' },
          { city_cd: 'KHA', violation_cd: '16',  violation_name: 'Parked without at least one license plate',                   ticket_charges: 'SAR 100', tow_charges: 'SAR 100', clamp_charges: 'SAR 75' },
          { city_cd: 'KHA', violation_cd: '21',  violation_name: 'Park in Sand Areas',                                          ticket_charges: 'SAR 100', tow_charges: 'SAR 100', clamp_charges: 'SAR 75' },
          { city_cd: 'KHA', violation_cd: '22',  violation_name: 'Obstructing an authorized personal from executing their duties', ticket_charges: 'SAR 200', tow_charges: 'SAR 100', clamp_charges: 'SAR 75' },
          { city_cd: 'KHA', violation_cd: '800', violation_name: 'Parked within the road and traffic area',                     ticket_charges: 'SAR 150', tow_charges: 'SAR 100', clamp_charges: 'SAR 75' },
          { city_cd: 'KHA', violation_cd: '801', violation_name: 'Parked in a non-parking area',                                ticket_charges: 'SAR 150', tow_charges: 'SAR 100', clamp_charges: 'SAR 75' },
          { city_cd: 'KHA', violation_cd: '802', violation_name: 'Parked on pedestrian or buildings entries',                   ticket_charges: 'SAR 200', tow_charges: 'SAR 100', clamp_charges: 'SAR 75' },
          { city_cd: 'KHA', violation_cd: '803', violation_name: 'Parked on the pavement or on a pedestrian area',              ticket_charges: 'SAR 150', tow_charges: 'SAR 100', clamp_charges: 'SAR 75' },
          { city_cd: 'KHA', violation_cd: '804', violation_name: 'Parked facing the opposite direction of traffic flow',        ticket_charges: 'SAR 150', tow_charges: 'SAR 100', clamp_charges: 'SAR 75' },
          { city_cd: 'KHA', violation_cd: '805', violation_name: 'Parked in an officially reserved space',                      ticket_charges: 'SAR 150', tow_charges: 'SAR 100', clamp_charges: 'SAR 75' },
          { city_cd: 'KHA', violation_cd: '806', violation_name: 'Parked in a suspended space/temporary out of use',            ticket_charges: 'SAR 150', tow_charges: 'SAR 100', clamp_charges: 'SAR 75' },
          { city_cd: 'KHA', violation_cd: '807', violation_name: 'Placing obstacles or reservations on the parking space',      ticket_charges: 'SAR 300', tow_charges: 'SAR 100', clamp_charges: 'SAR 75' },
          { city_cd: 'KHA', violation_cd: '808', violation_name: 'Fencing or closing a parking space without a valid permit',   ticket_charges: 'SAR 200', tow_charges: 'SAR 100', clamp_charges: 'SAR 75' },
          { city_cd: 'KHA', violation_cd: '809', violation_name: 'Parked outside allowed time',                                 ticket_charges: 'SAR 100', tow_charges: 'SAR 100', clamp_charges: 'SAR 75' },
          { city_cd: 'KHA', violation_cd: '810', violation_name: 'Parked in violation of posted signs',                         ticket_charges: 'SAR 150', tow_charges: 'SAR 100', clamp_charges: 'SAR 75' },
          { city_cd: 'KHA', violation_cd: '811', violation_name: 'Parked on a fire hydrant bay',                                ticket_charges: 'SAR 250', tow_charges: 'SAR 100', clamp_charges: 'SAR 75' },
        ],
      },
    },

    assetsFallback: {
      table_key: 'khamis_on_street_assets',
      title: 'Khamis On-street',
      data: {
        groups: makeAssetGroups({
          ticketDispenser: '-', ticketVerifier: '-', apms: '-',
          pinPad: '-', cardReader: '-', bContactless: '-',
          rfidReader: '-', ipBarrier: '-', anprCamera: '-',
          slidingGate: '-',
          pnds: '119', tpalBna: '22', tpalTx: '72', tpalV2: '25',
          enfDevice: '66', oukitel: '19', doogee: '47',
          printer: '65', pr3: '24', sewoo: '5', bixolon: '36',
          towTruck: '4', clampVehicle: '2', supportVehicle: '1',
        }),
      },
    },
  },

  // ── Khamis Off-Street ───────────────────────────────────────────────
  khamis_off_street_profile: {
    profileKey:    'khamis_off_street_profile',
    membershipKey: 'khamis_off_street_membership',
    assetsKey:     'khamis_off_street_assets',
    pageType:      'off_street',

    profileFallback: {
      table_key: 'khamis_off_street_profile',
      title: 'Khamis Off-Street Profile',
      data: {
        total_bays:        { label: 'Total Off Street Car Park Bays', value: '125' },
        contract_term:     { value: '15 years' },
        contract_period:   { start_date: '19.11.2015', end_date: '17.06.2030' },
        operational_hours: { value: '16 Hours', from: '07:30', to: '23:30' },
        rate_per_hour:     { value: 'SAR 3.00 excluding 15% VAT' },
        membership_tariff: { value: 'excluding 15% VAT' },
      },
    },

    membershipFallback: {
      table_key: 'khamis_off_street_membership',
      title: 'Khamis Mushayith Off Street - Price List',
      data: {
        rows: [
          { category: 'Membership', amount: 'SAR 350' },
        ],
      },
    },

    assetsFallback: {
      table_key: 'khamis_off_street_assets',
      title: 'Khamis Off-street',
      data: {
        groups: makeAssetGroups({
          ticketDispenser: '1', g10064: '1',
          ticketVerifier: '1', evG10064: '1',
          apms: '-', pinPad: '-', cardReader: '-', bContactless: '-',
          rfidReader: '3', ipBarrier: '2', anprCamera: '2', arh: '2',
          slidingGate: '-', pnds: '-',
          enfDevice: '-', printer: '-', towTruck: '-', clampVehicle: '-', supportVehicle: '-',
        }),
      },
    },
  },
};


// ═══════════════════════════════════════════════════════════════════════
// SHARED PROFILE INFO BLOCK
// ═══════════════════════════════════════════════════════════════════════
const ProfileInfo = ({ pd, pageType, patchProfile, showMembership, effectiveTotalBays }) => (
  <div className="flex flex-col gap-1 mb-4">
    {/* 🔥 READ-ONLY Total Bays */}
    <div className="flex items-center gap-2">
      <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
      <span className="text-[12px]">
        {pd.total_bays?.label}{' '}
        <strong>
          <input 
            type="text" 
            value={effectiveTotalBays}
            readOnly 
            disabled
            className="font-bold outline-none bg-transparent !border-0 text-[12px] w-20 cursor-default" 
          />
        </strong>
      </span>
    </div>

    {/* Contract Term - Editable */}
    <div className="flex items-center gap-2 ml-4">
      <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
      <span className="text-[12px] flex items-center flex-wrap gap-1">
        Contract term{' '}
        <strong><input type="text" value={pd.contract_term?.value || ''}
          onChange={e => patchProfile('contract_term', 'value', e.target.value)}
          className="font-bold outline-none bg-transparent !border-0 text-[12px] w-12" /></strong>
        ; start date{' '}
        <strong><input type="text" value={pd.contract_period?.start_date || ''}
          onChange={e => patchProfile('contract_period', 'start_date', e.target.value)}
          className="font-bold outline-none bg-transparent !border-0 text-[12px] w-16" /></strong>
        {' to '}
        <strong><input type="text" value={pd.contract_period?.end_date || ''}
          onChange={e => patchProfile('contract_period', 'end_date', e.target.value)}
          className="font-bold outline-none bg-transparent !border-0 text-[12px] w-24" /></strong>
      </span>
    </div>

    {/* Operational Hours - Editable */}
    <div className="flex items-center gap-2 ml-4">
      <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
      <span className="text-[12px] flex items-center flex-wrap gap-1">
        Operational Hours{' '}
        <strong><input type="text" value={pd.operational_hours?.value || ''}
          onChange={e => patchProfile('operational_hours', 'value', e.target.value)}
          className="font-bold outline-none bg-transparent !border-0 text-[12px] w-13" /></strong>
        {' Per day '}
        <strong><input type="text" value={pd.operational_hours?.from || ''}
          onChange={e => patchProfile('operational_hours', 'from', e.target.value)}
          className="font-bold outline-none bg-transparent !border-0 text-[12px] w-9" /></strong>
        {' Hours to '}
        <strong><input type="text" value={pd.operational_hours?.to || ''}
          onChange={e => patchProfile('operational_hours', 'to', e.target.value)}
          className="font-bold outline-none bg-transparent !border-0 text-[12px] w-9" /></strong>
        {' Hours'}
      </span>
    </div>

    {/* Rate Per Hour - Editable */}
    <div className="flex items-center gap-2 ml-4">
      <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
      <span className="text-[12px]">
        Rate per Hour{' '}
        <strong><input type="text" value={pd.rate_per_hour?.value || ''}
          onChange={e => patchProfile('rate_per_hour', 'value', e.target.value)}
          className="font-bold outline-none bg-transparent !border-0 text-[12px] w-48" /></strong>
      </span>
    </div>

    {/* Assets Deployed */}
    <div className="flex items-center gap-2 ml-4">
      <div className="w-3 h-3 rounded-full bg-red-500 flex-shrink-0" />
      <span className="text-[12px]">Assets Deployed</span>
    </div>

    {/* Membership line — off-street only - Editable */}
    {showMembership && (
      <div className="flex items-center gap-2 ml-4">
        <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
        <span className="text-[12px]">
          Membership Rates{' '}
        <strong>
          <input type="text" value={pd.membership_tariff?.value || ''}
            onChange={e => patchProfile('membership_tariff', 'value', e.target.value)}
            className=" outline-none bg-transparent !border-0 text-[12px] w-72" />
        </strong>
        </span>
        
      </div>
    )}
  </div>
);

// ═══════════════════════════════════════════════════════════════════════
// MAIN COMPONENT
// ═══════════════════════════════════════════════════════════════════════
const KhamisProfile = ({ page, year = '', month = '', monthNumber = '', contract = '' }) => {
  const cfg = KHAMIS_PROFILE_CONFIG[page?.type];
  if (!cfg) return null;

  const hasFetchedRef = useRef(false);
  const saveRef       = useRef(null);
  const [isSaving, setIsSaving]               = useState(false);
  
  // 🔥 State for second API (parking bays)
  const [parkingBaysData, setParkingBaysData] = useState(null);
  
  const [profileTable, setProfileTable]       = useState(cfg.profileFallback);
  const [assetsTable, setAssetsTable]         = useState(cfg.assetsFallback);
  const [violationTable, setViolationTable]   = useState(cfg.violationFallback || null);
  const [membershipTable, setMembershipTable] = useState(cfg.membershipFallback || null);
  const { enqueue } = useApiQueue();

  // 🔥 Effective total bays - second API se aayega
  const effectiveTotalBays = parkingBaysData?.total_bays ?? profileTable?.data?.total_bays?.value ?? '0';

  // ── Refs for latest state (Stale State Fix) ─────────────────────────────
  const profileRef     = useRef(null);
  const assetsRef      = useRef(null);
  const violationRef   = useRef(null);
  const membershipRef  = useRef(null);

  // Sync refs with latest state
  useEffect(() => { profileRef.current   = profileTable;   }, [profileTable]);
  useEffect(() => { assetsRef.current    = assetsTable;    }, [assetsTable]);
  useEffect(() => { violationRef.current = violationTable; }, [violationTable]);
  useEffect(() => { membershipRef.current = membershipTable; }, [membershipTable]);
  
  // ── Fetch BOTH APIs ─────────────────────────────────────────────────────────────
  useEffect(() => {
    if (hasFetchedRef.current) return;
    hasFetchedRef.current = true;
    fetchAllData();
  }, [year, month, monthNumber, contract]);

  const fetchAllData = async () => {
    try {
      // 🔥 Second API params based on page type
      const isOnStreet = cfg.pageType === 'on_street';
      const secondApiParams = isOnStreet ? {
        contract: "0030009",
        year: year,
        month: month,
        device_onstreet: "KHA",
        type: "on_street"
      } : {
        contract: "0030016",
        year: year,
        month: month,
        type: "off_street"
      };
      
      const [firstApiResponse, secondApiResponse] = await Promise.all([
        enqueue(() => apiCall('GET', '/boardpack/get-tables-data', { year, contract, month: monthNumber })),
        enqueue(() => apiCall('GET', '/boardpack/parking/bays', secondApiParams))
      ]);

      // Process first API response
      if (firstApiResponse?.success) {
        const data = firstApiResponse?.data || [];
        const find = (key, fb) => data.find(t => t.table_key === key) || fb;

        setProfileTable(find(cfg.profileKey, cfg.profileFallback));
        setAssetsTable(find(cfg.assetsKey, cfg.assetsFallback));
        if (cfg.violationKey)  setViolationTable(find(cfg.violationKey, cfg.violationFallback));
        if (cfg.membershipKey) setMembershipTable(find(cfg.membershipKey, cfg.membershipFallback));
      }

      // 🔥 Process second API response for parking bays
      if (secondApiResponse?.success && secondApiResponse?.data) {
        setParkingBaysData(secondApiResponse.data);
      } else {
        console.warn("Second API failed:", secondApiResponse?.message);
        setParkingBaysData(null);
      }
      
    } catch (err) {
      console.error('Fetch error:', err);
    }
  };

  // ── Auto-save ─────────────────────────────────────────────────────────
  const autoSave = () => {
    if (saveRef.current) clearTimeout(saveRef.current);
    saveRef.current = setTimeout(saveToAPI, API_CALL_TIME);
  };

  // ── Fixed saveToAPI using Refs ────────────────────────────────────────────
  const saveToAPI = async () => {
    try {
      setIsSaving(true);

      const tables = [
        { 
          table_key: profileRef.current?.table_key, 
          title: profileRef.current?.title, 
          data: profileRef.current?.data 
        },
        { 
          table_key: assetsRef.current?.table_key, 
          title: assetsRef.current?.title, 
          data: assetsRef.current?.data 
        },
      ];

      if (violationRef.current) {
        tables.push({ 
          table_key: violationRef.current.table_key, 
          title: violationRef.current.title, 
          data: violationRef.current.data 
        });
      }
      if (membershipRef.current) {
        tables.push({ 
          table_key: membershipRef.current.table_key, 
          title: membershipRef.current.title, 
          data: membershipRef.current.data 
        });
      }

      const res = await apiCall('POST', '/boardpack/add-tables-data', {
        contract, 
        year, 
        month: monthNumber, 
        created_by: 1, 
        tables,
      });

      if (!res?.success) throw new Error(res?.message || 'Save failed');
    } catch (err) {
      console.error('Save error:', err);
      toast.error('Failed to save changes');
    } finally {
      setIsSaving(false);
    }
  };

  // ── Patch helpers ─────────────────────────────────────────────────────
  const patchProfile = (field, subField, value) => {
    setProfileTable(prev => ({
      ...prev,
      data: { ...prev.data, [field]: subField ? { ...prev.data[field], [subField]: value } : value },
    }));
    autoSave();
  };

  const handleViolationCell = (rIdx, key, value) => {
    setViolationTable(prev => ({
      ...prev,
      data: { ...prev.data, rows: prev.data.rows.map((r, i) => i === rIdx ? { ...r, [key]: value } : r) },
    }));
    autoSave();
  };

  const handleMembershipCell = (rIdx, key, value) => {
    setMembershipTable(prev => ({
      ...prev,
      data: { ...prev.data, rows: prev.data.rows.map((r, i) => i === rIdx ? { ...r, [key]: value } : r) },
    }));
    autoSave();
  };

  const handleAssetSubCount = (flatIdx, value) => {
    const flat = groupsToFlat(assetsRef.current?.data?.groups || []).map((a, i) => i === flatIdx ? { ...a, subCount: value } : a);
    setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
    autoSave();
  };

  const handleAssetTotalCount = (flatIdx, value) => {
    const flat = groupsToFlat(assetsRef.current?.data?.groups || []).map((a, i) => i === flatIdx ? { ...a, totalCount: value } : a);
    setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
    autoSave();
  };

  const pd         = profileTable.data;
  const flatAssets = groupsToFlat(assetsTable.data.groups);
  const pageType   = cfg.pageType;

  // ═══════════════════════════════════════════════════════════════════
  // RENDER
  // ═══════════════════════════════════════════════════════════════════
  return (
    <div className="min-h-screen p-8 bg-white">

      {/* ── Header ── */}
      <div className="flex justify-between items-center mb-3">
        <div className="ml-2">
          <img src={Khamis} alt="Khamis Logo" style={{ height: '50px', objectFit: 'contain' }} />
        </div>
        <h1 className="text-xl font-bold flex-1 text-center">{profileTable.title}</h1>
      </div>

      {/* ══════════════════════════════════════
          ON-STREET PAGE
      ══════════════════════════════════════ */}
      {pageType === 'on_street' && (
        <>
          <div className="flex flex-row gap-0 !border-2 !border-black p-3">
            {/* LEFT */}
            <div className="flex-1 pr-4">
              <div className="flex flex-col">
                {/* Activities icons */}
                <div className="mb-4">
                  <div className="flex gap-8">
                    <p className="text-[16px] font-bold mb-3">Activities:</p>
                    {['On Street', 'Enforcement'].map(label => (
                      <div key={label} className="flex flex-col items-center gap-2">
                        {label === 'On Street' ? 
                          <img src={OnStreet} alt="On Street" style={{ height: '120px', objectFit: 'contain' }} /> : 
                          <img src={Enforcement} alt="Enforcement" style={{ height: '120px', objectFit: 'contain' }} />}
                      </div>
                    ))}
                  </div>
                </div>
                <ProfileInfo pd={pd} pageType={pageType} patchProfile={patchProfile} showMembership={false} effectiveTotalBays={effectiveTotalBays} />
              </div>

              {/* Violation Table - Editable */}
              {violationTable && (
                <div className="mt-2">
                  <p className="text-[9px] font-semibold mb-1">{violationTable.title}</p>
                  <table className="!border-collapse text-[8px]">
                    <thead>
                      <tr className="bg-gray-300">
                        {['City_Cd', 'Violation_Cd', 'Violation_Name_En', 'Ticket_Charges', 'Tow_Charges', 'Clamp_Charges'].map(h => (
                          <th key={h} className="!border !border-black px-2 py-1 font-bold text-center"
                            style={{ minWidth: h === 'Violation_Name_En' ? '200px' : '65px' }}>
                            {h}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {violationTable.data.rows.map((row, rIdx) => (
                        <tr key={rIdx} className="bg-white">
                          {[
                            { key: 'city_cd', w: '45px' },
                            { key: 'violation_cd', w: '50px' },
                            { key: 'violation_name', isLong: true },
                            { key: 'ticket_charges', w: '60px' },
                            { key: 'tow_charges', w: '60px' },
                            { key: 'clamp_charges', w: '60px' },
                          ].map(({ key, w, isLong }) => (
                            <td key={key} className="!border !border-black px-1 py-0.5 align-top">
                              {isLong ? (
                                <textarea
                                  value={row[key] || ''}
                                  onChange={e => handleViolationCell(rIdx, key, e.target.value)}
                                  rows={1}
                                  className="!border-0 bg-transparent outline-none text-[8px] resize-none w-full"
                                  style={{ minWidth: '260px', overflow: 'hidden' }}
                                  onInput={e => {
                                    e.target.style.height = 'auto';
                                    e.target.style.height = e.target.scrollHeight + 'px';
                                  }}
                                />
                              ) : (
                                <input
                                  type="text"
                                  value={row[key] || ''}
                                  onChange={e => handleViolationCell(rIdx, key, e.target.value)}
                                  className="!border-0 bg-transparent outline-none text-[8px] text-center"
                                  style={{ width: w }}
                                />
                              )}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>

            {/* RIGHT — Assets */}
            <AssetsPanel assetsTable={assetsTable} flatAssets={flatAssets}
              onSubCount={handleAssetSubCount} onTotalCount={handleAssetTotalCount} />
          </div>
        </>
      )}

      {/* ══════════════════════════════════════
          OFF-STREET PAGE
      ══════════════════════════════════════ */}
      {pageType === 'off_street' && (
        <div className="flex flex-row gap-0 !border-2 !border-black p-3">
          {/* LEFT */}
          <div className="flex-1 pr-4">
            {/* Car Park icon + info */}
            <div className="flex items-start gap-4 mb-4">
              <div className="items-center justify-center text-[8px] text-gray-400">
                <img src={CarPark} alt="Car Park" style={{ height: '50px', objectFit: 'contain' }} />
              </div>
              <div className="flex-1">
                <ProfileInfo pd={pd} pageType={pageType} patchProfile={patchProfile} showMembership={true} effectiveTotalBays={effectiveTotalBays} />
              </div>
            </div>

            {/* Price List Table - Editable */}
            {membershipTable && (
              <div className="ml-4">
                <p className="text-[9px] font-semibold mb-2">{membershipTable.title}</p>
                <table className="!border-collapse text-[10px]">
                  <thead>
                    <tr className="bg-gray-300">
                      <th className="!border !border-black px-6 py-2 font-bold text-left" style={{ minWidth: '250px' }}>Category</th>
                      <th className="!border !border-black px-6 py-2 font-bold text-center" style={{ minWidth: '120px' }}>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {membershipTable.data.rows.map((row, rIdx) => (
                      <tr key={rIdx} className="bg-white">
                        <td className="!border !border-black px-4 py-2">
                          <input type="text" value={row.category || ''} onChange={e => handleMembershipCell(rIdx, 'category', e.target.value)}
                            className="!border-0 bg-transparent outline-none text-[10px] w-full" />
                        </td>
                        <td className="!border !border-black px-4 py-2 text-center">
                          <input type="text" value={row.amount || ''} onChange={e => handleMembershipCell(rIdx, 'amount', e.target.value)}
                            className="!border-0 bg-transparent outline-none text-[10px] text-center w-full" />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>

          {/* RIGHT — Assets */}
          <AssetsPanel assetsTable={assetsTable} flatAssets={flatAssets}
            onSubCount={handleAssetSubCount} onTotalCount={handleAssetTotalCount} />
        </div>
      )}
    </div>
  );
};

export default KhamisProfile;